import { type BiLogger } from '../../../Provider/BiLogger/BiLogger';
import { type AppDispatch } from '../../../../store';
import {
  onShippingMethodSelected,
  type SelectionOption,
  type OnShippingMethodSelectedReturn,
} from '../../../../actions/googlePay/onShippingMethodSelected';

type CreateOnShippingMethodSelectedParams = {
  transactionInfo: google.payments.api.TransactionInfo;
  biLogger: BiLogger;
  dispatch: AppDispatch;
};

type CreateOnShippingMethodSelectedReturn = Promise<OnShippingMethodSelectedReturn>;

type CreateOnShippingMethodSelected = (
  params: CreateOnShippingMethodSelectedParams,
) => (selectionOption: SelectionOption) => CreateOnShippingMethodSelectedReturn;

export type OnShippingMethodSelected = ReturnType<CreateOnShippingMethodSelected>;

export const createOnShippingMethodSelected: CreateOnShippingMethodSelected =
  ({ transactionInfo, biLogger, dispatch }) =>
  (selectionOption) => {
    return dispatch(onShippingMethodSelected({ transactionInfo, biLogger, selectionOption })).unwrap();
  };
